import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(() => ({
  headBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "20px",
  },
  headText: {
    fontFamily: "poppins",
    fontWeight: 500,
    fontSize: "16px",
    color: "#272525",
    textTransform: "capitalize",
  },
  modalButton: {
    textTransform: "capitalize",
    width: "100%",
    // color: "black",
    fontSize: "14px",
  },
  crossIconBtn: {
    padding: "0px",
    color: "#272525",
    fontSize: "small",
    cursor: "pointer",
  },
  crossIconIcon: {
    width: "24px",
    height: "24px",
  },
  centerBody: {},
  //

  bottomBtnBar: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    gap: "30px",
  },

  saveButton: {
    width: "100%",
    border: "1px solid #4D1277",
    color: "#fff",
    backgroundColor: "#4D1277",
    borderRadius: "6px",
    fontFamily: "poppins",
    fontWeight: 400,
    fontSize: "14px",
    "&:hover": {
      color: "#fff",
      backgroundColor: "#4D1277",
      boxShadow: "none",
    },
    textTransform: "capitalize",
    boxShadow: "none",
  },
  cancelBtn: {
    width: "100%",
    border: "1px solid #272525",
    color: "#272525",
    backgroundColor: "#fff",
    borderRadius: "6px",
    fontFamily: "poppins",
    fontWeight: 400,
    fontSize: "14px",
    "&:hover": {
      color: "#272525",
      backgroundColor: "#fff",
      boxShadow: "none",
    },
    textTransform: "capitalize",
    boxShadow: "none",
  },

  divider: {
    background: "#DFE2E5",
    height: "1px",
  },
  //
}));

export default useStyles;

export const modalBoxStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "auto",
  bgcolor: "#fff",
  borderRadius: "20px",
  padding: "30px",
  border: "none",
  outline: "none",
  boxShadow: "none",
};
